import BaseService from "./Base.Service";

class ToolService extends BaseService {
    constructor() {
		super("companies");
	}

    // ViaCEP, de fora: fetch simples, sem o axios da API (que mandaria o token e a
    // empresa ativa para outro site). null quando o CEP não existe ou a busca falha.
    async searchForCep(cep) {
        const digits = String(cep || "").replace(/\D/g, "");
        if (digits.length !== 8) return null;
        try {
            const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
            if (!response.ok) return null;
            const data = await response.json();
            return data?.erro ? null : data;
        } catch (err) {
            return null;
        }
    }
}

export default ToolService;
